import React from 'react';
import { Box, Button, Flex, Popover, PopoverBody, PopoverContent, PopoverTrigger, Text } from '@chakra-ui/react';
import CheckIcon, { MoreIcon, TrashcanIcon, EditIcon2 } from '@assets/icons.js';
import { useConfirmModal } from '@store/useConfirmModal';
import { useEditDetail } from '@pages/ConsumerPromotion/hooks/state/useEditDetail';
import usePaginationStore from '@pages/ConsumerPromotion/hooks/state/usePagination';

const renderComp = (value) => <Text>{value ?? ''}</Text>;

export const tableList = [
    {
        title: 'SKU Id',
        value: 'sku_id',
        width: 152,
        component: ({ value }) => renderComp(value),
    },
    {
        title: 'Brand',
        value: 'brand',
        width: 130,
        component: ({ value }) => {
            const safeValue = String(value ?? '');
            const removeText = safeValue.replace('brand:', '');
            return renderComp(removeText);
        },
    },
    {
        title: 'Produk',
        value: 'name',
        width: 530,
        component: ({ value }) => renderComp(value),
    },
    {
        title: 'Base Pack',
        value: 'is_basepack',
        width: 150,
        component: ({ value }) => {
            const Icon = value ? CheckIcon : Box;
            return (
                <Flex alignItems={'center'}>
                    <Icon />
                </Flex>
            );
        },
    },
    {
        title: 'Barcode',
        value: 'barcode',
        width: 160,
        component: ({ value }) => renderComp(value),
    },
    {
        title: <Text fontWeight={700}>Action</Text>,
        value: 'id',
        key: 'action',
        width: 66,
        component: (props) => {
            const stateEdit = useEditDetail();
            const stateConfirm = useConfirmModal();
            const { deleteItem } = usePaginationStore();

            const hanldeEdit = () => {
                stateEdit.set({
                    editingRow: props,
                    searchMasterDataSku: props.name,
                });
            };

            const hanldeDelete = () => {
                stateConfirm.set({
                    isOpen: true,
                    title: 'Hapus Product?',
                    desc: 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk menambahkan produk.',
                    onSubmit: () => {
                        return deleteItem(props.id);
                    },
                });
            };

            return (
                props &&
                !props.is_basepack_child && (
                    <Popover placement="bottom-start">
                        <PopoverTrigger>
                            <Button variant={'unstyled'} justifySelf={'end'} px={0} minW={'10px'}>
                                <MoreIcon />
                            </Button>
                        </PopoverTrigger>
                        <PopoverContent>
                            <PopoverBody w={'full'} _hover={{ bg: 'sagitarius.100' }}>
                                <Button variant={'unstyled'} onClick={hanldeEdit} color={'sagitarius.500'}>
                                    <EditIcon2 size={18} />
                                    Edit
                                </Button>
                            </PopoverBody>
                            <PopoverBody _hover={{ bg: 'danger.100' }}>
                                <Button variant={'unstyled'} onClick={hanldeDelete} color={'danger.500'}>
                                    <TrashcanIcon size={18} />
                                    Delete
                                </Button>
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>
                )
            );
        },
    },
];
